import { render, staticRenderFns } from "./CalendarDialog.vue?vue&type=template&id=4f8c9d56&scoped=true&"
import script from "./CalendarDialog.vue?vue&type=script&lang=js&"
export * from "./CalendarDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c9d56",
  null
  
)

export default component.exports